import React from "react";
import { styled } from "@mui/material/styles";
import {
  Paper,
  Typography,
  Stack,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import HeightBox from "../HeightBox";
import { getAge } from "../../util/calculations.utils";

const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  boxShadow: "none",
}));

const CustomTypography = styled(Typography)(({ theme }) => ({
  fontSize: "11pt",
  fontWeight: 400,
  padding: "10pt 40pt",
}));
const CustomTypographyChild = styled(Typography)(({ theme }) => ({
  fontSize: "10.5pt",
  fontWeight: 800,
}));

export const AffidavitHaveChildrenPrintOut = React.forwardRef((props, ref) => {
  const { formValues } = props;
  const district = formValues.district;
  const secreteriat = formValues.secreterial;
  const passport = formValues.passport;
  const passport_issued = formValues.passport_issued;
  const village = formValues.village;
  const addressOne = formValues.address;
  const name = formValues.fullName;
  const religion = formValues?.religion;
  const lieceneNumber = formValues?.lieceneId;
  const idNumber = formValues?.nationalId;
  const spouse = formValues?.spouse;
  const children = [
    {
      id: formValues?.child1name,
      name: formValues?.child1name,
      birthday: formValues?.child1db,
      age: formValues?.child1age,
    },
    {
      id: formValues?.child2name,
      name: formValues?.child2name,
      birthday: formValues?.child2db,
      age: formValues?.child2age,
    },
    {
      id: formValues?.child3name,
      name: formValues?.child3name,
      birthday: formValues?.child3db,
      age: formValues?.child3age,
    },
    {
      id: formValues?.child4name,
      name: formValues?.child4name,
      birthday: formValues?.child4db,
      age: formValues?.child4age,
    },
    {
      id: formValues?.child5name,
      name: formValues?.child5name,
      birthday: formValues?.child5db,
      age: formValues?.child5age,
    },
  ];

  const numberOfChildren = children.filter((c) => c.id !== null).length;

  return (
    <Container ref={ref}>
      <style type="text/css" media="print">
        {"\
   @page { size: portrait; }\
"}
      </style>
      <img
        src="/images/affidavit_have_children.jpg"
        alt=""
        style={{
          position: "absolute",
          height: "100%",
          width: "100%",
          zIndex: -1,
        }}
      />
      <HeightBox height={200} />
      {/* //adress */}
      <CustomTypography>
        ශ්‍රී ලංකා ප්‍රජාතන්ත්‍රවාදී ජනරජයේ<span style={{fontWeight:800}}> {"  "}{district}{"  "} </span>දිස්ත්‍රික්කයේ<span style={{fontWeight:800}}>{"  "}
        {secreteriat}{"  "} </span>ප්‍රාදේශීය ලේකම් කොට්ඨාසයේ<span style={{fontWeight:800}}>
        {"  "}{village}{"  "}</span> ග්‍රාමයේ<span style={{fontWeight:800}}> {"    "}{addressOne}{"  "} </span> ලිපිනයෙහි පදිංචි <span style={{fontWeight:800}}>{"  "}{name}{"  "}
        </span> වන මම <span style={{fontWeight:800}}> {"  "}{religion}{"  "}</span> බැතිමතියෙක් වශයෙන් අවංකවත් සත්‍ය ලෙසත් ගාම්භීරපූර්වකවත්
        පහත සදහන් පරිදි දිවුරා ප්‍රතිඥා කර සිටිමි.<br></br> 01.ඉහත නම සදහන්
        දිවුරුම් ප්‍රකාශයේ දිවුරුම් ප්‍රකාශිකාව මම වෙමි.
        <br /> 02.මාගේ ගමන් බලපත්‍ර අංකය <span style={{fontWeight:800}}> {"  "}{passport}{"  "}</span> වන අතර එය නිකුත් කරන දිනය<span style={{fontWeight:800}}> {" "}
        {passport_issued}{"  "} </span> සහ මාගේ හැදුනුම්පත් අංකය <span style={{fontWeight:800}}> {"  "}{idNumber}{"  "} </span> වේ.
        <br /> 03.මා විවාහක වන අතර මාගේ ස්වාමි පුරුෂයාගේ නම <span style={{fontWeight:800}}> {"  "}{spouse}{"  "}</span> වේ.
        <br /> 04.මා හට වයස අවුරුදු 5 ඉක්මවූ දරුවන් <span style={{fontWeight:800}}> {"  "}{numberOfChildren}{"  "}</span> සිටින අතර
        ඔවුන්ගේ විස්තර පහත දැක්වේ.
      </CustomTypography>
      <HeightBox height={28} />
      <TableContainer sx={{ margin: "auto", width: "80%" }}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>නම</TableCell>
              <TableCell align="right">උපන්දිනය</TableCell>
              <TableCell align="right">වයස</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {children?.map(
              (item) =>
                item.name && (
                  <TableRow
                    key={item.name}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {item.name}
                    </TableCell>
                    <TableCell align="right">{item.birthday}</TableCell>
                    <TableCell align="right">{getAge(item.birthday)}</TableCell>
                  </TableRow>
                )
            )}
            {/* {rows.map((row) => (
              
            ))} */}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomTypography>
        <br />
        05.මා හට මීට අමතරව වයස අවුරුදු 5 ට අඩු දරුවන් නොමැත.
        <br /> 06.මා විදේශගත වූ පසු මාගේ ............................................. (ඥාති සම්බන්ධය) 
        වන ...................................................... ( නම සහ ජාතික හැඳුනුම්පත් අංකය ) විසින් ඉහත
        දරුවන් සුරක්ෂිතව බලා ගන්නවා ඇත.
      </CustomTypography>

      <HeightBox height={450} />
    </Container>
  );
});
